var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Form } from "@brushfire/ui";
import { useContext, useEffect } from "react";
import Constants from "../../../data/constants";
import WidgetFieldset from "../../Helpers/WidgetFieldset";
import FormikContextListener from "../../Helpers/FormikContextListener";
import { AppFormContext, FooterVisibility } from "../../../App";
var PostAttendeeConfirmation = function (_a) {
    var eventData = _a.eventData, path = _a.path, confirmationMessage = _a.confirmationMessage, setConfirmationMessage = _a.setConfirmationMessage;
    var setFooterVisibility = useContext(AppFormContext).setFooterVisibility;
    var onSubmit = function (values, formikHelpers, setGlobalError) {
        formikHelpers.setSubmitting(false);
        setConfirmationMessage(undefined);
    };
    useEffect(function () {
        if (confirmationMessage) {
            if (setFooterVisibility) {
                setFooterVisibility(FooterVisibility.show);
            }
        }
        return function () {
            if (setFooterVisibility) {
                setFooterVisibility(FooterVisibility.default);
            }
        };
    }, [confirmationMessage]);
    return (_jsxs("div", __assign({ style: { minHeight: "200px" } }, { children: [_jsx(Form, __assign({ initialValues: {}, onSubmit: onSubmit, formikBagProps: {
                    submitButtonLabel: "Finish",
                }, useUnsavedPrompt: false }, { children: function (_a) {
                    var formikContext = _a.formikContext;
                    return (_jsx(_Fragment, { children: _jsx(WidgetFieldset, { children: _jsx("div", __assign({ className: "pos-relative" }, { children: _jsx(FormikContextListener, { currentPath: path, path: [
                                        Constants.Routes.myDashboard,
                                        Constants.Routes.myAttendees,
                                        Constants.Routes.myGroup,
                                        Constants.Routes.myOrder,
                                        Constants.Routes.myAttendee,
                                        Constants.Routes.myGroupAttendees,
                                        Constants.Routes.myOrderAttendees,
                                    ], formikContext: formikContext, active: true, initialValues: {}, focusDelay: 500 }) })) }) }));
                } })), _jsxs("div", __assign({ className: "absolute-center ta-center" }, { children: [_jsx("h1", __assign({ className: "bold tt-uppercase mega m-bottom-medium" }, { children: confirmationMessage.title })), _jsx("h3", __assign({ className: "bold" }, { children: confirmationMessage.subtitle }))] }))] })));
};
export default PostAttendeeConfirmation;
